import base from './base';
import data from './data/exchange';

const exchangeApi = {};

exchangeApi.checkExchange = () => {
  return base.fetch(data.checkExchange, 300);
};
exchangeApi.getExchangeInfo = () => {
  return base.fetch(data.exchangeInfo, 300);
};
exchangeApi.getExchangeNexonPointInfo = () => {
  return base.fetch(data.exchangeNexonPointInfo, 300);
};
exchangeApi.getBankList = () => {
  return base.fetch(data.bankList, 300);
};
exchangeApi.getExchangeInit = () => {
  return base.fetch(data.exchangeInit, 300);
};
exchangeApi.setExchangeAccountRegist = (val) => {
  console.log(val);
  return base.fetch(data.setExchangeAccountRegist, 300);
};
exchangeApi.setExchangeRequest = (val) => {
  console.log(val);
  return base.fetch(data.exchangeRequest, 300);
};
exchangeApi.getExchangeHistory = (val) => {
  console.log(val);
  return base.fetch(data.exchangeHistory, 300);
};
exchangeApi.getGlobalExchangeHistory = (val) => {
  console.log(val);
  return base.fetch(data.globalExchangeHistory, 300);
};
exchangeApi.getKrpcNotice = () => {
  return base.fetch(data.krpcNotice, 300);
};
exchangeApi.getGlobalNotice = () => {
  return base.fetch(data.globalNotice, 300);
};
exchangeApi.checkGlobalExchange = () => {
  return base.fetch(data.checkGlobalExchange, 300);
};
exchangeApi.checkGlobalExchangeNexonPoint = () => {
  return base.fetch(data.checkGlobalExchangeNexonPoint, 1000);
};
exchangeApi.reserveWithdraw = () => {
  return base.fetch(data.reserveWithdraw, 300);
};
exchangeApi.requestNexonPointWithdraw = (val) => {
  console.log(val);
  return base.fetch(data.exchangeNexonPointRequest, 300);
};
export default {
  ...exchangeApi,
};
